"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var wizard2;
            (function (wizard2) {
                class InitArgs {
                    constructor() {
                        this.firstToClaimId = appn.emptyString;
                        this.allToCompleteId = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    appn.tasks.init(_initArgs.firstToClaimId, _initArgs.allToCompleteId, false);
                }
                wizard2.init = init;
            })(wizard2 = taskTemplates.wizard2 || (taskTemplates.wizard2 = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
